/** JobDetailRoute — skin-aware switcher for /jobs/:id. */
import { useUISkin } from "@/data/UISkinContext";
import JobDetail from "./JobDetail";
import JobDetailCockpit from "./JobDetailCockpit";

export default function JobDetailRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <JobDetailCockpit />;
  return <JobDetail />;
}
